import React from "react";
import { ThemeProvider } from "styled-components";
import GlobalStyles from "./styles/GlobalStyles"; 
import Navbar from "./components/Navbar";

import Home from "./sections/Home";
import About from "./sections/About";
import Experience from "./sections/Experience";
import Projects from "./sections/Projects";
import Contact from "./sections/Contact";
import Footer from "./components/Footer";

const theme = {
  background: "#f8f9fa", 
  text: "#333", 
  navbar: "#ffffff", 
  navbarText: "#333", 
  navbarHover: "#007bff", 
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />
      <Navbar />

      <Home />
      <About />
      <Experience />
      <Projects />
      <Contact />
      <Footer />
    </ThemeProvider>
  );
}

export default App;
